import React, { useEffect, useState } from "react"
import { accordionUniqueId } from "@/utils/index"

import Collapsible from "react-collapsible"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/Bundles/localization"

import { handleZipDownload } from "@/utils/helper"

import {
  accordianClickBundleFeature,
  addAnlyticsForSDownloadSpec,
} from "@/components/Bundles/analytics"

import Button from "@/components/core/Button/Button"
import CollapsibleHeader from "@/components/Bundles/StaticBundle/BundlesAccordian/CollapsibleHeader"

const SpecsInstallation = props => {
  const { title = "", parentSku = "", isOpen = false, items = [] } = props

  const [specAndInstall, setSpecAndInstall] = useState({})
  const [isDisabledSpec, setIsDisabledSpec] = useState(false)
  const [isDisabledInstall, setIsDisabledInstall] = useState(false)

  const { t } = useTranslation("common")

  const {
    specsInstallationLabel = "",
    downloadAllSpecSheetsLabel = "",
    downloadAllInstallGuidesLabel = "",
  } = getTranslations(t)

  const { specFiles = [], installGuidesFiles = [] } = specAndInstall

  const handleDownloadSpecZip = async (
    downloadAllSpecSheetsLabel = "",
    mainTitle = ""
  ) => {
    setIsDisabledSpec(true)
    try {
      const selectedFileList = []
      specFiles.forEach(selectedObj => {
        const techFileInfo = selectedObj.substring(
          selectedObj.lastIndexOf("/") + 1
        )
        selectedFileList.push(techFileInfo)
      })

      addAnlyticsForSDownloadSpec(
        downloadAllSpecSheetsLabel,
        selectedFileList,
        specFiles,
        mainTitle
      )
      await handleZipDownload(specFiles, parentSku)
      setIsDisabledSpec(false)
    } catch {
      setIsDisabledSpec(false)
    }
  }

  const handleDownloadInstallGuidesZip = async (
    downloadAllSpecSheetsLabel = "",
    mainTitle = ""
  ) => {
    setIsDisabledInstall(true)
    try {
      const selectedFileList = []
      installGuidesFiles.forEach(selectedObj => {
        const techFileInfo = selectedObj.substring(
          selectedObj.lastIndexOf("/") + 1
        )
        selectedFileList.push(techFileInfo)
      })

      addAnlyticsForSDownloadSpec(
        downloadAllSpecSheetsLabel,
        selectedFileList,
        installGuidesFiles,
        mainTitle
      )
      await handleZipDownload(installGuidesFiles, parentSku)
      setIsDisabledInstall(false)
    } catch {
      setIsDisabledInstall(false)
    }
  }

  const handleOpenAccordian = (title = "") => {
    accordianClickBundleFeature(title.toLowerCase(), "expand")
  }
  const handleCloseAccordian = (title = "") => {
    accordianClickBundleFeature(title.toLowerCase(), "collapse")
  }

  useEffect(() => {
    const specFiles = []
    const installGuidesFiles = []
    items.forEach(e => {
      const { installGuides = [], specPDFFiles = [] } = e

      installGuidesFiles.push(...installGuides)
      specFiles.push(...specPDFFiles)
    })

    setSpecAndInstall({ installGuidesFiles, specFiles })
  }, [items])

  return specFiles.length || installGuidesFiles.length ? (
    <div
      className="collapsible-accordion bundle-accordian-section"
      data-testid={`bundle-product-accordion-${title}`}
    >
      <Collapsible
        trigger={<CollapsibleHeader title={specsInstallationLabel} />}
        onTriggerOpening={() => handleOpenAccordian(specsInstallationLabel)}
        onTriggerClosing={() => handleCloseAccordian(specsInstallationLabel)}
        triggerOpenedClassName="collapsible__trigger--open"
        open={isOpen}
        openedClassName="collapsible--open"
        transitionTime={400}
        tabIndex="0"
        easing="ease-in-out"
        triggerElementProps={{
          id: accordionUniqueId("collapsible-trigger", 9999, 1000),
        }}
        contentElementId={accordionUniqueId("collapsible-content", 9999, 1000)}
      >
        <div
          className="row no-gutters px-0"
          data-testid={`colapse-data-${title}`}
          aria-disabled={isOpen}
        >
          <div className="col-12 bundles-accordian-button">
            {specFiles.length ? (
              <Button
                type="ghost"
                role="button"
                label={downloadAllSpecSheetsLabel}
                onClick={() =>
                  handleDownloadSpecZip(
                    downloadAllSpecSheetsLabel.toLowerCase(),
                    specsInstallationLabel.toLowerCase()
                  )
                }
                disabled={isDisabledSpec}
                loading={isDisabledSpec}
              />
            ) : null}
            {installGuidesFiles.length ? (
              <Button
                type="ghost"
                role="button"
                label={downloadAllInstallGuidesLabel}
                onClick={() =>
                  handleDownloadInstallGuidesZip(
                    downloadAllInstallGuidesLabel.toLowerCase(),
                    specsInstallationLabel.toLowerCase()
                  )
                }
                disabled={isDisabledInstall}
                loading={isDisabledInstall}
              />
            ) : null}
          </div>
        </div>
      </Collapsible>
    </div>
  ) : null
}

export default SpecsInstallation
